import type ModuleButtonsType from '../components/ModuleButtonsType';
import { showDeleteDialog, showDetailsReportingDialog, Utils } from 'app/main/components';
import { showAddNotesDialog } from 'app/main/submodules/notes/NotesAddDialog';
import { shareDetailsPage } from 'app/main/components/dialogs/ShareDialog';
import { showFastAddDialog } from '../components/FastAddDialog';
import { deleteMailchimpList } from './components/DemsManagerActions';
import { showDemsLogListDialog } from './dems-logs/DemsLogListDialog';
import { showDemsDefaultRecipientAddDialog } from './view/tabs/DemsDefaultRecipientsTab';

const buttons: ModuleButtonsType = {
	view: {
		itemButtons: [
			// {
			// 	name: 'VIEW_ITEM_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'VIEW_ITEM_BUTTON_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'dems'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(showFastAddDialog({ module: 'dems', updateRefresh, isUpdate: true, model }))
			},
			{
				name: 'VIEW_ITEM_BUTTON_ADD_COPY',
				icon: 'content-copy',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('create', 'dems'),
				action: ({ model, t }) => {
					const {
						dems_title,
						dems_date,
						dems_maac_uid,
						dems_user_assigned_uid,
						user_assigned_title,
						dems_grps_uid,
						grps_title,
						dems_warning_desc,
						dems_blocked_desc,
						dems_tags,
						dems_descriptionhtml
					} = model;
					Utils.openLink({
						pathname: '/dems/add',
						state: {
							model: {
								dems_date,
								dems_maac_uid,
								dems_user_assigned_uid,
								user_assigned_title,
								dems_grps_uid,
								grps_title,
								dems_warning_desc,
								dems_blocked_desc,
								dems_tags,
								dems_descriptionhtml,
								dems_title: dems_title + t('COPY')
							}
						}
					});
				}
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_NOTE',
				icon: 'comment-text-multiple-outline',
				iconAdd: true,
				action: ({ model, dispatch }) =>
					dispatch(showAddNotesDialog({ model: { note_table: 'dems', note_table_uid: model.dems_uid } }))
			},
			{
				name: 'DEMS_MAILCHIMP_DELETE_LIST',
				icon: 'close-box',
				disabled: ({ model }) => model.dems_dmst_id !== 5,
				hidden: ({ model }) => model.dems_connector !== 'mailchimp',
				action: ({ model, dispatch, updateRefresh, t }) =>
					deleteMailchimpList({ dispatch, t, demsUid: model.dems_uid }, updateRefresh)
			},
			{
				name: 'VIEW_ITEM_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'dems'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showDeleteDialog({
							module: 'dems',
							id: model.dems_uid,
							title: model.dems_title,
							updateRefresh
						})
					)
			}
		],
		headerButtons: [
			// {
			// 	name: 'VIEW_HEADER_BUTTON_SELECT',
			// 	icon: 'square-outline',
			// 	action: ({ switchIsSelecting }) => switchIsSelecting()
			// },
			{
				name: 'VIEW_HEADER_BUTTON_NEW',
				icon: 'plus-circle',
				hidden: ({ authorizer }) => authorizer.cannot('create', 'dems'),
				action: () => Utils.openLink({ pathname: '/dems/add' })
			}
		],
		fabs: [
			{
				id: 'default-recipients',
				name: 'DEMS_DEFAULT_RECIPIENTS_ADD_BUTTON',
				icon: 'plus-circle',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'dems'),
				action: ({ dispatch, updateRefresh }) => dispatch(showDemsDefaultRecipientAddDialog({ updateRefresh }))
			}
		]
	},
	details: {
		headerButtons: [
			// {
			// 	name: 'DETAILS_HEADER_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'DETAILS_HEADER_BUTTON_EXPORT',
				icon: 'file-export',
				hidden: ({ authorizer }) => authorizer.cannot('export', 'dems'),
				action: ({ model, dispatch, settings, sysSettings }) =>
					showDetailsReportingDialog({ model, dispatch, settings, sysSettings })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHARE',
				icon: 'share-variant',
				action: ({ model, dispatch, settings, t }) => shareDetailsPage({ model, dispatch, settings, t })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHOW_LOG',
				icon: 'timeline-clock-outline',
				disabled: ({ isEdit }) => isEdit,
				hidden: ({ authorizer }) => authorizer.cannot('view', 'logs'),
				action: ({ switchShowLogs }) => switchShowLogs()
			},
			{
				name: 'LOGS',
				icon: 'timetable',
				disabled: ({ isEdit }) => isEdit,
				hidden: ({ authorizer }) => authorizer.cannot('view', 'logs'),
				action: ({ model, dispatch }) =>
					dispatch(
						showDemsLogListDialog({
							model,
							module: 'sys_logs',
							filters: [
								{
									filt_field: `logs_table_uid`,
									filt_clause: 'equals',
									filt_value: model.dems_uid
								},
								{
									filt_field: `logs_lgty_id`,
									filt_clause: 'equals',
									filt_value: 5
								}
							]
						})
					)
			},
			{
				name: 'DETAILS_HEADER_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'dems'),
				action: ({ model, dispatch }) =>
					dispatch(
						showDeleteDialog({
							module: 'dems',
							id: model.dems_uid,
							title: model.dems_title
						})
					)
			}
		],
		fabs: [
			{
				id: 'summary',
				name: 'ACTION_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'dems'),
				action: ({ switchEdit }) => switchEdit()
			}
		]
	}
};

export default buttons;
